import { axiosApi } from "shared/api/axios";

export interface ApiResponse {
    status: number;
    data?: any;
    error?: string;
}

export const postAreas = async (values: object): Promise<ApiResponse> => {
    try {
        const response = await axiosApi.post(`${process.env.API_BACKEND}/v1/areas/area/`, values);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error: any) {
        console.error(error);
        throw error;
    }
}